module.exports = __webpack_public_path__ + "img/jy.8a44a7dc.png";